import React, { memo } from 'react';

import PropTypes from 'prop-types';

import '../../styles/revamp/aligner-page-card.scss';

function AlignerPageCard(props) {
  const { item } = props;
  return (
    <div className="aligner-page-card">
      <div className="corner-div" />
      <p className="step-no">{item.step}</p>
      <div className="card-top">
        <img
          src={`/img/updated/homepage/aligner-card-images/step_${item.step}.svg`}
          alt="smile assessment"
          data-gumlet="false"
        />
        <p className="step-text">
          <span>{item.titleText}</span>
          {' '}
          {item.text}
        </p>
      </div>

      <div className="card-bottom">
        <p className="price-tag">{item.priceTag ? item.priceTag : 'Free'}</p>
        <p className="step-info">{item.info}</p>
      </div>
    </div>
  );
}
export default memo(AlignerPageCard);
AlignerPageCard.propTypes = {
  item: PropTypes.shape()
};

AlignerPageCard.defaultProps = {
  item: {}
};
